/** One-line HTML to plain text for CRT readouts */
export function stripHtmlToText(html: string | null | undefined, maxLen = 900): string {
  if (!html?.trim()) return ''
  const t = html
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  return t.length > maxLen ? `${t.slice(0, maxLen)}…` : t
}

export function wrapTerminalWidth(s: string, width = 76): string[] {
  const words = s.split(/\s+/).filter(Boolean)
  const lines: string[] = []
  let cur = ''
  for (const w of words) {
    const next = cur ? `${cur} ${w}` : w
    if (next.length > width && cur) {
      lines.push(cur)
      cur = w
    } else {
      cur = next
    }
  }
  if (cur) lines.push(cur)
  return lines.length ? lines : ['']
}
